import { fillDriverName } from '@/utils/templateVariables'

export function buildLeadEmailBody({
  driverName,
  template,
  signature,
}: {
  driverName: string
  template: string
  signature: string
}): string {
  const base = fillDriverName(template, driverName)
  const trimmedSig = signature.trim()
  if (!base) return trimmedSig ? `${trimmedSig}\n` : ''
  return trimmedSig ? `${base}\n\n${trimmedSig}\n` : `${base}\n`
}
